import { COUNT_SECTIONS, EPetFeeMethod, TCustomPetFee, TPriceValue } from 'data/types/petFee.types';

export const isCustomFee = (fee: TCustomPetFee | null | undefined): boolean =>
  !!fee && fee.method !== EPetFeeMethod.FLAT;

export const getCustomMethodLabel = (method: EPetFeeMethod): string => {
  if (method === EPetFeeMethod.BY_PET_SPECIES) return 'By Species';
  if (method === EPetFeeMethod.BY_PETS_COUNT) return 'By Pet Count';
  return '';
};

export const formatFeeDisplayValue = (fee: TCustomPetFee | null | undefined): string => {
  if (!fee) return '$ -';
  if (isCustomFee(fee)) return getCustomMethodLabel(fee.method);
  return `$ ${fee.flatRate ?? '-'}`;
};

const formatPriceValue = (price: TPriceValue): string => {
  const hasValue = price.value !== null;
  const hasRange = price.min !== null && price.max !== null;
  const valStr = hasValue ? `$ ${price.value}` : '';
  const rangeStr = hasRange ? `$ ${price.min} - $ ${price.max}` : '';
  if (hasValue && hasRange) return `${valStr} (${rangeStr})`;
  if (hasValue) return valStr;
  if (hasRange) return rangeStr;
  return '$ -';
};

export const formatCustomFeeLabel = (fee: TCustomPetFee): string[] => {
  const { bySpeciesRates, byPetCountRates } = fee;

  if (fee.method === EPetFeeMethod.BY_PET_SPECIES && bySpeciesRates) {
    return bySpeciesRates.entries.map(({ specieName, price }) => `${specieName}: ${formatPriceValue(price)}`);
  }

  if (fee.method === EPetFeeMethod.BY_PETS_COUNT && byPetCountRates) {
    return COUNT_SECTIONS.map(({ label, key }) => `${label}: ${formatPriceValue(byPetCountRates[key])}`);
  }

  return [];
};
